import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PanAppState } from '@panamax/app-state';
import { Crumb } from 'src/app/shared/components/breadcrumbs/breadcrumbs.component';
import { PageTitle } from '../../../shared/constants/page-titles.enum';

@Component({
  selector: 'app-notifications-header',
  templateUrl: './notifications-header.component.html',
  styleUrls: ['./notifications-header.component.scss'],
})
export class NotificationsHeaderComponent {
  @Input() stickyHeader: boolean;
  @Input() isDesktop: boolean;
  @Input() allRead: boolean;
  @Input() allReadTmNotes: boolean;
  @Input() hasFilters: boolean;
  @Input() activeTab: string;
  @Input() unreadAlertCount: number;
  @Input() unreadNoteCount: number;
  @ViewChild('tabContainer', { static: false }) tabContainer: ElementRef;
  @Output() openFilters: EventEmitter<any> = new EventEmitter<any>();
  @Output() markAllAsRead: EventEmitter<any> = new EventEmitter<any>();
  @Output() switchTab: EventEmitter<any> = new EventEmitter<any>();
  breadcrumbs: Crumb[];

  constructor(readonly panAppState: PanAppState) {
    this.breadcrumbs = [
      {
        label: 'i18n.breadcrumbs.home',
        url: '/desktop/home',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.notifications',
        url: '',
        active: true,
      },
    ];
  }

  markAllNotificationsAsRead() {
    this.markAllAsRead.emit();
  }

  filter() {
    this.openFilters.emit();
  }

  triggerSwitchTab(activeTab: string) {
    this.switchTab.emit(activeTab);
    const containerElement = this.tabContainer?.nativeElement;
    if (containerElement) {
      containerElement.classList.toggle('add-bounce');
      setTimeout(() => {
        if (containerElement) {
          containerElement.classList.remove('add-bounce');
        }
      }, 600);
    }
  }
}
